/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        label: {
            formField: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "0.8125rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                height: {
                    value: "32px",
                    type: "dimension",
                },
            },
            checkbox: {
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.125rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                gap: {
                    value: "6px",
                    type: "dimension",
                },
                disabled: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
